



























import Vue from 'vue'
export default Vue.extend({
  props: {
    viewId: {
      type: String
    }
  },

  data() {
    return {
      videos: [] as any[]
    }
  },

  methods: {
    getVideos() {
      const videos = [] as any[]
      let videosRef = this.$db.collection("videos")
      let query

      const claims = this.$store.state.auth.token.claims

      if (claims.super) {
        query = videosRef
      } else if (claims.partner) {
        query = videosRef.where('partners', 'array-contains', claims.partner)
      } else if (claims.client) {
        query = videosRef.where('clients', 'array-contains', claims.client)
      } else {
        query = videosRef.where('users', 'array-contains', this.$store.state.auth.user.uid)
      }
      query.orderBy('order', 'desc').get().then(snapshot => {
        if (snapshot.size) {
          snapshot.forEach(doc => {
            videos.push({_id: doc.id, ...doc.data()})
          })
        }
        this.videos = videos.filter(video => video.views.indexOf(this.viewId) > -1)
        if (videos.length === 1) { this.$emit('videoSelected', videos[0])}
      }).catch(err => {
        window.console.log(err)
      })
    }
  },

  created() {
    this.getVideos()
  }
})
